import { useLocation } from 'quartz-routing/react-router';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { PlayerPlayIcon } from 'foundations-assets/icons/components/PlayerPlayIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import { View } from 'foundations-components/transitional/components/View';
import { useTheme } from 'foundations-theming/utils';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import UsageTracker from '../../../utils/UsageTracker';
import { useLessonPreQuizSession } from '../hooks/useLessonPreQuiz.migrated';
import { derivePreQuizDisplayStatus, getPreAssessmentTrackingProps } from '../utils/preAssessmentQuizUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LessonPreQuizOptionalTab = ({
  lesson,
  screen,
  to,
  track
}) => {
  const theme = useTheme();
  const location = useLocation();
  const {
    getLessonPreQuizState
  } = useLessonPreQuizSession();
  const quizState = getLessonPreQuizState(lesson.id);
  const displayStatus = derivePreQuizDisplayStatus(quizState);
  const {
    interactionProps
  } = useMemo(() => getPreAssessmentTrackingProps({
    lesson,
    track,
    screen
  }), [lesson, track, screen]);
  const progressPercentage = quizState && quizState.totalQuestions > 0 ? Math.round(quizState.questionIndex / quizState.totalQuestions * 100) : 0;
  const handleClick = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, interactionProps, {
      action: 'ai-pre-assessment-tab-clicked'
    }));
  };
  return /*#__PURE__*/_jsx(ACRouterLink, {
    onClick: handleClick,
    to: Object.assign({}, location, {
      pathname: to
    }),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-accent-light-orange-subtle-alt",
      borderColor: "border-accent-light-orange-default",
      borderStyle: "solid",
      borderWidth: "100",
      padding: "400",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          flexGrow: 1,
          children: [displayStatus === 'COMPLETED' && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h6",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.preAssessmentQuiz.nav.complete.title"
              })
            }), /*#__PURE__*/_jsx(Text, {
              as: "small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.preAssessmentQuiz.nav.complete.subtitle"
              })
            })]
          }), displayStatus === 'IN_PROGRESS' && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h6",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.preAssessmentQuiz.nav.inProgress.title"
              })
            }), /*#__PURE__*/_jsx(Text, {
              as: "small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.preAssessmentQuiz.nav.inProgress.subtitle"
              })
            })]
          }), displayStatus !== 'COMPLETED' && displayStatus !== 'IN_PROGRESS' && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h6",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.preAssessmentQuiz.nav.available.title"
              })
            }), /*#__PURE__*/_jsx(Text, {
              as: "small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.preAssessmentQuiz.nav.available.subtitle"
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          flexShrink: 0,
          children: [displayStatus !== 'COMPLETED' && displayStatus !== 'IN_PROGRESS' && /*#__PURE__*/_jsx(IconHolder, {
            borderColor: "icon-core-default",
            borderRadius: "full",
            borderStyle: "solid",
            borderWidth: "200",
            icon: PlayerPlayIcon,
            size: "200"
          }), displayStatus === 'IN_PROGRESS' && /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            flexGrow: 1,
            children: [/*#__PURE__*/_jsx(View, {
              backgroundColor: "fill-surface-default",
              blockSize: "4px",
              borderRadius: "full",
              overflow: "hidden",
              position: "relative",
              children: /*#__PURE__*/_jsx(NanoProgress, {
                color: theme.color['text-core-default'],
                height: 4,
                value: progressPercentage
              })
            }), /*#__PURE__*/_jsx(Text, {
              textAlign: "center",
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(FormattedPercentage, {
                  precision: 0,
                  value: progressPercentage
                })
              })
            })]
          }), displayStatus === 'COMPLETED' && /*#__PURE__*/_jsx(IconHolder, {
            borderColor: "icon-core-default",
            borderRadius: "full",
            borderStyle: "solid",
            borderWidth: "200",
            icon: SuccessIcon,
            size: "200"
          })]
        })]
      })
    })
  });
};